(() => {
  const batUrl = 'https://cdn.shopify.com/s/files/1/0814/9647/3935/files/europe-mark-halloween-reference-bat.png?v=1791391520';

  const make = (tag, className) => {
    const node = document.createElement(tag);
    node.className = className;
    node.setAttribute('aria-hidden', 'true');
    return node;
  };

  const svgWrap = (className, viewBox, markup) => {
    const node = make('span', className);
    node.innerHTML = '<svg viewBox="' + viewBox + '" focusable="false" aria-hidden="true">' + markup + '</svg>';
    return node;
  };

  const makeBat = ({x, y, size, speed, delay, opacity, flap, mobileHide = false}) => {
    const bat = make('span', 'em-footer-bat');
    bat.style.setProperty('--x', x);
    bat.style.setProperty('--y', y);
    bat.style.setProperty('--size', size);
    bat.style.setProperty('--speed', speed);
    bat.style.setProperty('--delay', delay);
    bat.style.setProperty('--opacity', opacity);
    bat.style.setProperty('--flap', flap);
    if (mobileHide) bat.dataset.mobileHide = 'true';

    const image = document.createElement('img');
    image.src = batUrl;
    image.alt = '';
    image.decoding = 'async';
    image.draggable = false;
    image.setAttribute('aria-hidden', 'true');
    bat.append(image);
    return bat;
  };

  const makeEmber = ({x, y, size, speed, delay}) => {
    const ember = make('span', 'em-footer-ember');
    ember.style.setProperty('--x', x);
    ember.style.setProperty('--y', y);
    ember.style.setProperty('--size', size);
    ember.style.setProperty('--speed', speed);
    ember.style.setProperty('--delay', delay);
    return ember;
  };

  const branchMarkup = `
    <path d="M4 18 C35 10 52 19 78 7 C93 1 108 6 124 20 C107 15 98 19 90 31 C106 25 122 31 142 46 C119 36 102 39 86 54 C68 69 49 77 29 86 C43 65 44 46 35 33 C25 19 14 16 4 18 Z" fill="#08020c"/>
    <path d="M72 10 C80 -3 92 -2 101 4 C90 5 84 12 81 22 Z" fill="#08020c"/>
    <path d="M108 19 C123 5 140 10 151 21 C136 17 126 22 118 33 Z" fill="#08020c"/>
  `;

  const castleMarkup = `
    <path d="M10 100 L17 59 L33 59 L38 31 L45 59 L59 59 L68 10 L77 59 L91 59 L98 40 L104 59 L123 59 L131 100 Z" fill="#07020b"/>
    <rect x="23" y="69" width="8" height="14" fill="#8d45bd" opacity=".66"/>
    <rect x="46" y="67" width="8" height="15" fill="#8d45bd" opacity=".66"/>
    <rect x="71" y="51" width="8" height="14" fill="#8d45bd" opacity=".72"/>
    <rect x="101" y="72" width="8" height="13" fill="#8d45bd" opacity=".64"/>
    <path d="M55 100 V84 C55 76 61 72 67 72 C74 72 80 76 80 84 V100 Z" fill="#64268f" opacity=".75"/>
    <path d="M4 100 H138" stroke="#07020b" stroke-width="7" stroke-linecap="round"/>
  `;

  const pumpkinMarkup = `
    <g transform="translate(2 4)">
      <ellipse cx="24" cy="28" rx="18" ry="19" fill="#f45f0c" stroke="#7d2303" stroke-width="1.2"/>
      <ellipse cx="50" cy="31" rx="16" ry="17" fill="#ff7819" stroke="#8a2804" stroke-width="1.2"/>
      <ellipse cx="75" cy="27" rx="18" ry="19" fill="#e95308" stroke="#761e02" stroke-width="1.2"/>
      <path d="M21 11 C20 4 25 2 28 1 C27 7 30 9 29 13 Z" fill="#4f6227"/>
      <path d="M48 15 C47 10 50 8 53 7 C52 11 55 13 54 16 Z" fill="#4f6227"/>
      <path d="M72 10 C71 4 76 2 79 1 C78 7 81 9 80 12 Z" fill="#4f6227"/>
      <g fill="#1d0702">
        <path d="M13 26 L21 21 L23 30 Z"/><path d="M35 26 L27 21 L25 30 Z"/>
        <path d="M17 37 C22 41 27 41 32 37 L29 34 L27 37 L24 34 L21 37 L19 34 Z"/>
        <path d="M41 30 L48 25 L50 34 Z"/><path d="M60 30 L53 25 L51 34 Z"/>
        <path d="M43 41 C48 44 53 44 58 41 L55 38 L53 41 L50 38 L47 41 L45 38 Z"/>
        <path d="M64 25 L72 20 L74 29 Z"/><path d="M86 25 L78 20 L76 29 Z"/>
        <path d="M68 36 C73 40 78 40 83 36 L80 33 L78 36 L75 33 L72 36 L70 33 Z"/>
      </g>
    </g>
  `;

  const build = (footer) => {
    footer.classList.add('em-footer--halloween');
    if (footer.querySelector('.em-footer-halloween-scene[data-em-server-scene="true"]')) return;
    footer.querySelectorAll('.em-footer-halloween-scene').forEach((node) => node.remove());

    const scene = make('div', 'em-footer-halloween-scene');

    const pumpkinLeft = svgWrap('em-footer-pumpkin em-footer-pumpkin--left', '0 0 100 58', pumpkinMarkup);
    pumpkinLeft.style.setProperty('--size', '228px');
    pumpkinLeft.style.setProperty('--opacity', '.56');
    pumpkinLeft.style.setProperty('--speed', '7.2s');
    pumpkinLeft.style.setProperty('--delay', '-1.8s');

    const pumpkinCenter = svgWrap('em-footer-pumpkin em-footer-pumpkin--center', '0 0 100 58', pumpkinMarkup);
    pumpkinCenter.style.setProperty('--size', '178px');
    pumpkinCenter.style.setProperty('--opacity', '.32');
    pumpkinCenter.style.setProperty('--speed', '8.1s');
    pumpkinCenter.style.setProperty('--delay', '-4.2s');

    const pumpkinRight = svgWrap('em-footer-pumpkin em-footer-pumpkin--right', '0 0 100 58', pumpkinMarkup);
    pumpkinRight.style.setProperty('--size', '238px');
    pumpkinRight.style.setProperty('--opacity', '.54');
    pumpkinRight.style.setProperty('--speed', '7.7s');
    pumpkinRight.style.setProperty('--delay', '-3.6s');

    scene.append(
      make('span', 'em-footer-moon'),
      make('span', 'em-footer-fog em-footer-fog--one'),
      make('span', 'em-footer-fog em-footer-fog--two'),
      make('span', 'em-footer-horizon'),
      svgWrap('em-footer-branch em-footer-branch--left', '0 0 155 92', branchMarkup),
      svgWrap('em-footer-branch em-footer-branch--right', '0 0 155 92', branchMarkup),
      svgWrap('em-footer-castle', '0 0 142 110', castleMarkup),

      makeBat({x:'12%', y:'24%', size:'55px', speed:'8.7s', delay:'-1.2s', opacity:'.24', flap:'.64s'}),
      makeBat({x:'28%', y:'47%', size:'40px', speed:'7.6s', delay:'-4.1s', opacity:'.18', flap:'.70s', mobileHide:true}),
      makeBat({x:'45%', y:'18%', size:'48px', speed:'9.2s', delay:'-5.4s', opacity:'.21', flap:'.66s'}),
      makeBat({x:'63%', y:'42%', size:'44px', speed:'8.1s', delay:'-2.7s', opacity:'.19', flap:'.72s'}),
      makeBat({x:'80%', y:'25%', size:'58px', speed:'9s', delay:'-4.8s', opacity:'.23', flap:'.62s'}),
      makeBat({x:'92%', y:'53%', size:'36px', speed:'7.4s', delay:'-6.1s', opacity:'.17', flap:'.74s', mobileHide:true}),

      pumpkinLeft,
      pumpkinCenter,
      pumpkinRight,

      makeEmber({x:'10%', y:'62%', size:'2px', speed:'5.9s', delay:'-1.4s'}),
      makeEmber({x:'22%', y:'31%', size:'1px', speed:'6.8s', delay:'-3.1s'}),
      makeEmber({x:'37%', y:'68%', size:'2px', speed:'7.4s', delay:'-4.6s'}),
      makeEmber({x:'54%', y:'24%', size:'1px', speed:'6.3s', delay:'-2.2s'}),
      makeEmber({x:'70%', y:'71%', size:'2px', speed:'7.1s', delay:'-5.3s'}),
      makeEmber({x:'86%', y:'36%', size:'1px', speed:'6.5s', delay:'-1.9s'})
    );

    footer.prepend(scene);
  };

  const init = (root = document) => {
    root.querySelectorAll('footer[id^="EuropeMarkFooter-"].em-footer').forEach(build);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();